/* LeParfin V9 : ticket à gratter qui remplace la roue Klaviyo (sections/lp-scratch.liquid, assets/lp-scratch.css).
   Étape 1 : on gratte (doigt ou souris, la page ne défile pas). Étape 2 : « Vous avez gagné une offre mystère »,
   puis email et consentement obligatoire. Étape 3 : après la réponse 202 de Klaviyo, l'offre et le code.
   Le code n'est jamais affiché sans email. Une ouverture automatique par session au plus, déclencheur en coin
   tant que l'email n'a pas été donné. Dans l'éditeur : aperçu, rien n'est envoyé ni mémorisé. */
(() => {
  'use strict';
  if (window.__lpTicket) return;
  window.__lpTicket = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const DAY = 864e5;
  const NB = ' ';
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  /* Image suivante, avec un repli si l'onglet ne dessine pas (requestAnimationFrame suspendu). */
  const nextFrame = (fn) => {
    let done = false;
    const go = () => { if (!done) { done = true; fn(); } };
    requestAnimationFrame(() => requestAnimationFrame(go));
    setTimeout(go, 80);
  };
  const reduced = () => !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  const coarse = () => !!(window.matchMedia && matchMedia('(pointer: coarse)').matches);
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const store = {
    get(k, session) { try { const v = (session ? sessionStorage : localStorage).getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } },
    set(k, v, session) { try { (session ? sessionStorage : localStorage).setItem(k, JSON.stringify(v)); } catch (e) { /* stockage indisponible */ } }
  };
  const publish = (name, data) => {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) { /* rien */ }
  };
  const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function frDate(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || '').trim());
    if (!m) return '';
    const d = parseInt(m[3], 10);
    return (d === 1 ? '1er' : String(d)) + NB + MONTHS[parseInt(m[2], 10) - 1] + ' ' + m[1];
  }
  function todayIso() {
    const d = new Date();
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function decode(c) { try { return atob(c || ''); } catch (e) { return ''; } }
  function visible(el) {
    const cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
    const r = el.getBoundingClientRect();
    return r.width > 120 && r.height > 60 && r.right > 0 && r.bottom > 0 && r.left < innerWidth && r.top < innerHeight;
  }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  function setup(host) {
    if (!host || host.__tk) return;
    host.__tk = true;
    let cfg;
    try { cfg = JSON.parse($('[data-tk-data]', host).textContent); } catch (e) { return; }
    const T = cfg.t || {};
    const design = !!(cfg.design || (window.Shopify && Shopify.designMode));
    const KEY = 'lp_ticket:' + cfg.campaign;
    /* Visiteur venu d'un email Klaviyo (déjà inscrit) : ni ouverture ni déclencheur, mémorisé comme l'email donné. */
    if (!design) {
      let kx = false;
      try {
        const q = new URLSearchParams(location.search);
        const v = (n) => String(q.get(n) || '').trim().toLowerCase();
        kx = q.has('_kx') || v('utm_source') === 'klaviyo' || v('utm_medium') === 'email';
      } catch (e) { /* rien */ }
      const s0 = store.get(KEY) || {};
      if (kx && !s0.klaviyo) { s0.klaviyo = Date.now(); store.set(KEY, s0); }
      if (s0.klaviyo) return;
    }
    const allLots = (cfg.lots || []).filter((l) => l && l.id);
    const lots = allLots.filter((l) => l.w > 0 && l.c);
    if (!lots.length) return;
    const today = todayIso();
    if (!design) {
      /* Dates revérifiées ici (la page peut être servie depuis un cache). */
      if ((cfg.start && today < cfg.start) || (cfg.end && today > cfg.end)) return;
      const path = (location.pathname.replace(/\/+$/, '') || '/').toLowerCase();
      const excluded = (cfg.excluded || []).map((x) => (String(x).trim().replace(/\/+$/, '') || '').toLowerCase()).filter(Boolean);
      if (excluded.some((x) => path === x || (x !== '/' && path.indexOf(x + '/') === 0))) return;
    }

    let st = design ? {} : (store.get(KEY) || {});
    const save = () => { if (!design) store.set(KEY, st); };
    if (st.dismissed && !st.emailOk && !design) return;
    if (!design) {
      const pvKey = 'lp_ticket_pv:' + cfg.campaign;
      st.pv = (store.get(pvKey) || 0) + 1;
      store.set(pvKey, st.pv);
    }

    const trg = $('[data-tk-open]', host);
    const trgL = $('[data-tk-trg-label]', host);
    const wrap = $('[data-tk]', host);
    const dlg = $('.tk-d', host);
    const title = $('[data-tk-title]', host);
    const intro = $('[data-tk-intro]', host);
    const ticket = $('[data-tk-ticket]', host);
    const cv = $('[data-tk-canvas]', host);
    const prize = $('[data-tk-prize]', host);
    const prizeK = $('[data-tk-pk]', host);
    const prizeL = $('[data-tk-pl]', host);
    const prizeS = $('[data-tk-ps]', host);
    const prov = $('[data-tk-prov]', host);
    const acts = $('[data-tk-pre-actions]', host);
    const form = $('[data-tk-form]', host);
    const won = $('[data-tk-won]', host);
    const codeEl = $('[data-tk-code]', host);
    const copyBtn = $('[data-tk-copy]', host);
    const cta = $('[data-tk-cta]', host);
    const ment = $('[data-tk-ment]', host);
    const dismissBtn = $('[data-tk-dismiss]', host);
    const live = $('[data-tk-live]', host);
    const terms = $('[data-tk-terms]', host);
    if (!wrap || !dlg || !ticket || !cv || !form) return;

    let lot = null;
    let code = '';
    let isOpen = false;
    let revealed = false;
    let opener = null;
    let hideT = 0;
    let openedOnce = false;
    let step = 1;

    /* ---------- Tirage et contenu ---------- */
    function pickLot() {
      const tot = lots.reduce((a, l) => a + l.w, 0);
      let r = Math.random();
      try { const a = new Uint32Array(1); crypto.getRandomValues(a); r = a[0] / 4294967296; } catch (e) { /* repli */ }
      let x = r * tot;
      for (const l of lots) { x -= l.w; if (x < 0) return l; }
      return lots[lots.length - 1];
    }
    function currentLot() {
      let l = st.lot && (design ? allLots : lots).find((x) => x.id === st.lot);
      /* Lot désactivé depuis le tirage : nouveau tirage, sauf si l'offre a déjà été donnée. */
      if (!l && st.lot && st.emailOk && !design) l = allLots.find((x) => x.id === st.lot && x.c);
      if (!l) {
        l = pickLot();
        st.lot = l.id;
        st.drawnAt = Date.now();
        save();
      }
      return l;
    }
    const lotText = (l) => (l.label || '') + (l.sub ? ' ' + l.sub : '');
    function fillOffer(l) {
      lot = l;
      code = decode(l.c);
      const root = String(cfg.root || '/').replace(/\/?$/, '/');
      cta.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cfg.redirect || '/collections/all');
      if (prov) prov.hidden = !(l.prov && step === 3);
    }
    function fillTerms() {
      if (!terms || terms.__done) return;
      terms.__done = true;
      const tot = lots.reduce((a, l) => a + l.w, 0);
      const list = lots.map((l) => {
        const p = Math.round((l.w / tot) * 100);
        const pt = p < 1 ? (T.lessThanOne || 'moins de 1' + NB + '%') : p + NB + '%';
        return esc(lotText(l)) + ' (' + esc(pt) + ')';
      }).join(', ');
      let html = terms.innerHTML;
      if (!cfg.start) html = html.replace(/du \[debut\] au \[fin\]/g, "jusqu'au [fin]");
      html = html.split('[debut]').join(esc(frDate(cfg.start))).split('[fin]').join(esc(frDate(cfg.end) || '')).split('[lots]').join(list);
      terms.innerHTML = html;
    }

    /* ---------- Étapes ---------- */
    function setTitle(main, bold) {
      title.textContent = main || '';
      if (bold) { title.appendChild(document.createTextNode(' ')); const b = document.createElement('b'); b.textContent = bold; title.appendChild(b); }
    }
    function setStep(n, animate) {
      step = n;
      dlg.dataset.step = String(n);
      revealed = n >= 2;
      ticket.classList.toggle('is-revealed', revealed);
      ticket.classList.toggle('no-anim', !animate);
      prize.setAttribute('aria-hidden', revealed ? 'false' : 'true');
      if (revealed) { ticket.removeAttribute('role'); ticket.setAttribute('tabindex', '-1'); ticket.removeAttribute('aria-label'); }
      else { ticket.setAttribute('role', 'button'); ticket.setAttribute('tabindex', '0'); ticket.setAttribute('aria-label', ticket.dataset.aria || ''); }
      if (revealed && !animate) cv.style.display = 'none';
      if (n === 1) cv.style.display = '';
      if (intro) intro.hidden = n !== 1;
      acts.hidden = n !== 1;
      form.hidden = n !== 2;
      won.hidden = n !== 3;
      if (dismissBtn) dismissBtn.hidden = n === 3;
      if (n === 1) setTitle(T.title, T.titleBold);
      else if (n === 2) setTitle(T.wonTitle);
      else setTitle(T.unlockedTitle);
      if (n === 3) {
        /* L'offre et le code ne sont écrits dans la page qu'après l'inscription. */
        prizeK.textContent = T.resultEyebrow || '';
        prizeL.textContent = lot.label || '';
        prizeS.textContent = (T.resultLine || '').split('[code]').join(code);
        prizeS.hidden = !prizeS.textContent;
        codeEl.textContent = code;
        const notes = [T.offerNote, lot.cond].filter(Boolean);
        ment.textContent = notes.join(' ');
        ment.hidden = !notes.length;
        if (prov) prov.hidden = !lot.prov;
      } else {
        prizeK.textContent = T.mysteryKicker || '';
        prizeL.textContent = T.mysteryTitle || '';
        prizeS.textContent = '';
        prizeS.hidden = true;
        codeEl.textContent = '';
        ment.textContent = '';
        if (prov) prov.hidden = true;
      }
    }
    function stepFromState() { return st.emailOk ? 3 : (st.revealedAt ? 2 : 1); }

    /* ---------- Déclencheur en coin ---------- */
    function codeMode() {
      return !!(st.emailOk && (design || ((cfg.remindDays || 0) > 0 && Date.now() - st.emailOk < cfg.remindDays * DAY)));
    }
    function updateTrigger() {
      if (!trg) return;
      let show = !!cfg.trigger && (design || !st.dismissed);
      if (st.emailOk && !codeMode()) show = false;
      const cm = codeMode();
      if (trgL) trgL.textContent = cm ? (T.trgLabelCode || '') : (T.trgLabel || '');
      trg.setAttribute('aria-label', cm ? (T.trgAriaCode || '') : (T.trgAria || ''));
      trg.classList.toggle('is-code', cm);
      if (show && trg.hidden) { trg.hidden = false; if (!reduced()) trg.classList.add('is-in'); }
      else if (!show) trg.hidden = true;
    }
    /* Au-dessus de la barre d'achat collante (fiche) et du plateau de sélection. */
    function lift() {
      let h = 0;
      const sticky = document.querySelector('.sticky.on');
      if (sticky) h = Math.max(h, sticky.getBoundingClientRect().height);
      const tray = document.querySelector('.tray');
      if (tray && document.body.classList.contains('has-tray')) {
        const r = tray.getBoundingClientRect();
        if (r.height && r.top < innerHeight) h = Math.max(h, innerHeight - r.top);
      }
      host.style.setProperty('--tk-lift', h ? Math.round(h + 2) + 'px' : '0px');
    }

    /* ---------- Fenêtre ---------- */
    function focusables() {
      return $$('button, a[href], input, summary, [tabindex]:not([tabindex="-1"])', dlg).filter((el) => !el.disabled && !el.closest('[hidden]') && el.getClientRects().length);
    }
    function open(source) {
      if (isOpen) return;
      clearTimeout(hideT);
      warm();
      fillOffer(currentLot());
      fillTerms();
      setStep(stepFromState(), false);
      openedOnce = true;
      opener = document.activeElement;
      wrap.hidden = false;
      host.classList.add('is-open');
      document.documentElement.classList.add('tk-lock');
      isOpen = true;
      if (!st.shownAt) { st.shownAt = Date.now(); save(); }
      nextFrame(() => {
        if (!isOpen) return;
        wrap.classList.add('is-on');
        if (step === 1) paintCover();
      });
      setTimeout(() => focusEl(title || dlg), 60);
      publish('lp_ticket_open', { source: source || 'button', campaign: cfg.campaign, step });
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      wrap.classList.remove('is-on');
      host.classList.remove('is-open');
      if (!st.emailOk && !design) { st.closedAt = Date.now(); save(); }
      const fin = () => {
        wrap.hidden = true;
        document.documentElement.classList.remove('tk-lock');
      };
      if (reduced()) fin(); else hideT = setTimeout(fin, 330);
      updateTrigger();
      if (opener && document.contains(opener) && opener.focus) focusEl(opener);
    }
    function scrollToEl(el) {
      try { el.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { /* rien */ }
    }

    /* ---------- Grattage ---------- */
    let ctx = null;
    let dpr = 1;
    let W = 0;
    let H = 0;
    let drawn = false;
    let touched = false;
    let pid = null;
    let last = null;
    let queue = [];
    let raf = 0;
    let checkT = 0;
    let sampler = null;
    let grain = null;
    const brush = Math.max(6, cfg.brush || 24);

    function cssVar(n, fb) { const v = getComputedStyle(host).getPropertyValue(n).trim(); return v || fb; }
    function grainPattern(c) {
      if (!grain) {
        grain = document.createElement('canvas');
        grain.width = grain.height = 96;
        const g = grain.getContext('2d');
        const img = g.createImageData(96, 96);
        for (let i = 0; i < img.data.length; i += 4) {
          const v = Math.random() * 255;
          img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
          img.data[i + 3] = 26;
        }
        g.putImageData(img, 0, 0);
      }
      return c.createPattern(grain, 'repeat');
    }
    function loadImg(src) {
      return new Promise((res) => { const im = new Image(); im.crossOrigin = 'anonymous'; im.onload = () => res(im); im.onerror = () => res(null); im.src = src; });
    }
    async function paintCover() {
      const r = ticket.getBoundingClientRect();
      if (!r.width || revealed) return;
      /* Le dessous reste masqué (lp-scratch.css, .is-ready) tant que la couche à gratter n'est pas dessinée. */
      ticket.classList.remove('is-ready');
      dpr = Math.min(2, window.devicePixelRatio || 1);
      W = Math.round(r.width * dpr);
      H = Math.round(r.height * dpr);
      cv.width = W;
      cv.height = H;
      ctx = cv.getContext('2d');
      drawn = false;
      touched = false;
      const fontP = document.fonts && document.fonts.load ? Promise.race([document.fonts.load('700 32px "TheSeasons"').catch(() => {}), wait(800)]) : Promise.resolve();
      const imgP = cfg.coverImage ? Promise.race([loadImg(cfg.coverImage), wait(1500).then(() => null)]) : Promise.resolve(null);
      const [, im] = await Promise.all([fontP, imgP]);
      if (revealed || !isOpen) return;
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, W, H);
      if (im && im.width) {
        const s = Math.max(W / im.width, H / im.height);
        ctx.drawImage(im, (W - im.width * s) / 2, (H - im.height * s) / 2, im.width * s, im.height * s);
      } else {
        const g = ctx.createLinearGradient(0, 0, W, H);
        g.addColorStop(0, cssVar('--tk-c1', '#C9694E'));
        g.addColorStop(1, cssVar('--tk-c2', '#B85540'));
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, W, H);
        /* Reflet en diagonale */
        const sh = ctx.createLinearGradient(W * 0.2, 0, W * 0.8, H);
        sh.addColorStop(0, 'rgba(255,255,255,0)');
        sh.addColorStop(0.48, 'rgba(255,255,255,.16)');
        sh.addColorStop(0.56, 'rgba(255,255,255,0)');
        ctx.fillStyle = sh;
        ctx.fillRect(0, 0, W, H);
        /* Grain */
        ctx.save();
        ctx.scale(dpr, dpr);
        ctx.fillStyle = grainPattern(ctx);
        ctx.fillRect(0, 0, W / dpr, H / dpr);
        ctx.restore();
        /* Pointillés intérieurs et consigne */
        ctx.strokeStyle = 'rgba(255,255,255,.55)';
        ctx.lineWidth = 1.5 * dpr;
        ctx.setLineDash([5 * dpr, 6 * dpr]);
        const m = 12 * dpr;
        if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(m, m, W - 2 * m, H - 2 * m, 10 * dpr); ctx.stroke(); } else ctx.strokeRect(m, m, W - 2 * m, H - 2 * m);
        ctx.setLineDash([]);
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        const label = coarse() ? (T.touch || '') : (T.mouse || '');
        let fs = Math.round(Math.min(W * 0.075, H * 0.14));
        ctx.font = '700 ' + fs + 'px "TheSeasons", Georgia, serif';
        while (fs > 12 * dpr && ctx.measureText(label).width > W * 0.78) { fs -= dpr; ctx.font = '700 ' + fs + 'px "TheSeasons", Georgia, serif'; }
        ctx.fillText(label, W / 2, H / 2 + fs * 0.05);
        ctx.font = '600 ' + Math.round(11 * dpr) + 'px Archivo, "Helvetica Neue", Arial, sans-serif';
        ctx.globalAlpha = 0.85;
        ctx.fillText('LeParfin', W / 2, H / 2 - fs * 1.15);
        ctx.globalAlpha = 1;
      }
      /* Gomme : trait opaque (sinon le grattage n'efface qu'à moitié). */
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = 1;
      ctx.setLineDash([]);
      ctx.strokeStyle = '#000';
      ctx.fillStyle = '#000';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = brush * 2 * dpr;
      cv.style.display = '';
      drawn = true;
      ticket.classList.add('is-ready');
    }
    function point(e) {
      const r = cv.getBoundingClientRect();
      return [(e.clientX - r.left) * (W / r.width), (e.clientY - r.top) * (H / r.height)];
    }
    /* Dessin groupé à l'image suivante (repli sur un minuteur si requestAnimationFrame est ralenti). */
    function kick() {
      if (raf) return;
      raf = 1;
      let done = false;
      const go = () => { if (!done) { done = true; flush(); } };
      requestAnimationFrame(go);
      setTimeout(go, 32);
    }
    function flush() {
      raf = 0;
      if (!queue.length || !ctx) return;
      ctx.beginPath();
      for (const [a, b] of queue) {
        ctx.moveTo(a[0], a[1]);
        ctx.lineTo(b[0] === a[0] && b[1] === a[1] ? b[0] + 0.1 : b[0], b[1]);
      }
      ctx.stroke();
      queue = [];
      if (!checkT) checkT = setTimeout(measure, 150);
    }
    function measure() {
      checkT = 0;
      if (revealed || !drawn) return;
      if (!sampler) { sampler = document.createElement('canvas'); sampler.width = 48; sampler.height = 30; }
      const sx = sampler.getContext('2d', { willReadFrequently: true });
      sx.clearRect(0, 0, 48, 30);
      sx.drawImage(cv, 0, 0, 48, 30);
      const d = sx.getImageData(0, 0, 48, 30).data;
      let clear = 0;
      for (let i = 3; i < d.length; i += 4) if (d[i] < 110) clear++;
      if (clear / (48 * 30) >= (cfg.threshold || 45) / 100) reveal('scratch');
    }
    function down(e) {
      if (revealed || !drawn || pid !== null) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      try { cv.setPointerCapture(e.pointerId); } catch (err) { /* rien */ }
      pid = e.pointerId;
      last = point(e);
      queue.push([last, last]);
      if (!touched) { touched = true; publish('lp_ticket_scratch', { campaign: cfg.campaign }); }
      kick();
    }
    function move(e) {
      if (e.pointerId !== pid) return;
      e.preventDefault();
      const list = e.getCoalescedEvents ? e.getCoalescedEvents() : [];
      for (const ev of (list.length ? list : [e])) { const p = point(ev); queue.push([last, p]); last = p; }
      kick();
    }
    function up(e) {
      if (e.pointerId !== pid) return;
      pid = null;
      last = null;
      clearTimeout(checkT);
      checkT = setTimeout(measure, 0);
    }
    cv.addEventListener('pointerdown', down);
    cv.addEventListener('pointermove', move);
    cv.addEventListener('pointerup', up);
    cv.addEventListener('pointercancel', up);
    cv.addEventListener('lostpointercapture', up);
    /* Anciens iPhone : le geste ne doit jamais faire défiler la page. */
    cv.addEventListener('touchmove', (e) => { if (!revealed) e.preventDefault(); }, { passive: false });
    ticket.addEventListener('contextmenu', (e) => e.preventDefault());
    ticket.addEventListener('selectstart', (e) => e.preventDefault());

    /* Grattage automatique (bouton, clavier) : 0,7 s, puis révélation. */
    let autoRun = false;
    function autoScratch() {
      if (revealed || autoRun) return;
      if (!drawn || reduced()) { reveal('button'); return; }
      autoRun = true;
      ctx.lineWidth = Math.max(brush * 2 * dpr, H * 0.3);
      const t0 = performance.now();
      let prev = null;
      const tri = (x) => 1 - Math.abs((x % 2) - 1);
      const frame = (fn) => {
        let done = false;
        const go = () => { if (!done) { done = true; fn(performance.now()); } };
        requestAnimationFrame(go);
        setTimeout(go, 40);
      };
      const stepFn = (now) => {
        const k = Math.min(1, (now - t0) / 700);
        const p = [W * (0.04 + 0.92 * tri(k * 5)), H * (0.08 + 0.84 * k)];
        if (prev) queue.push([prev, p]);
        prev = p;
        flush();
        clearTimeout(checkT);
        checkT = 0;
        if (k < 1 && isOpen) frame(stepFn);
        else { autoRun = false; reveal('button'); }
      };
      frame(stepFn);
    }
    function reveal(how) {
      if (revealed) return;
      if (!design) { st.revealedAt = Date.now(); save(); }
      setStep(2, true);
      setTimeout(() => { if (revealed) cv.style.display = 'none'; }, 420);
      if (how === 'scratch' && coarse() && !reduced() && navigator.vibrate) { try { navigator.vibrate(12); } catch (e) { /* rien */ } }
      if (live) live.textContent = T.announceWon || '';
      /* Le formulaire arrive après la petite animation du ticket ; le clavier mobile ne s'ouvre pas tout seul. */
      setTimeout(() => {
        if (!isOpen || step !== 2) return;
        const ft = $('[data-tk-ft]', form);
        scrollToEl(form);
        focusEl(ft || title);
      }, 650);
      updateTrigger();
      publish('lp_ticket_reveal', { how: how || 'scratch', campaign: cfg.campaign });
    }
    ticket.addEventListener('keydown', (e) => {
      if (revealed) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); autoScratch(); }
    });
    ticket.dataset.aria = ticket.getAttribute('aria-label') || '';

    /* ---------- Formulaire email (Klaviyo, API publique client) ---------- */
    const emailIn = form.elements.email;
    const consentIn = form.elements.consent;
    const err = $('[data-tk-err]', form);
    const btn = $('[data-tk-fb]', form);
    const btnLabel = btn.textContent;
    let busy = false;
    /* V3.11 : chaque essai sans case cochée (ou sans email valable) se voit : la ligne fautive tremble et le message
       réapparaît (Clarity : clics sans effet sur « Recevoir mon offre »). */
    const shake = (el) => { if (!el) return; el.classList.remove('is-err'); void el.offsetWidth; el.classList.add('is-err'); };
    const fail = (m, field) => {
      err.textContent = m;
      err.hidden = false;
      err.classList.remove('is-on'); void err.offsetWidth; err.classList.add('is-on');
      if (field) { field.setAttribute('aria-invalid', 'true'); shake(field.closest('.tk-cb, .tk-fr')); focusEl(field); }
    };
    [emailIn, consentIn].forEach((f) => f.addEventListener(f.type === 'checkbox' ? 'change' : 'input', () => {
      f.removeAttribute('aria-invalid');
      const row = f.closest('.tk-cb, .tk-fr');
      if (row) row.classList.remove('is-err');
      if (!err.hidden) err.hidden = true;
    }));
    function subscribe(email) {
      const k = cfg.klaviyo || {};
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: k.source || 'Ticket à gratter',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: { source: k.source || 'Ticket à gratter', lp_ticket_offre: lotText(lot), lp_ticket_code: code, lp_ticket_campagne: cfg.campaign },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: k.list } } }
        }
      };
      const send = () => fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.key || ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
        body: JSON.stringify(body)
      }).then((r) => (r.status === 202 || r.ok ? 'ok' : (r.status === 400 ? 'invalid' : 'error')));
      /* Un nouvel essai automatique si le réseau a coupé. */
      return send().catch(() => wait(900).then(send)).catch(() => 'error');
    }
    /* V61 (10/10/2026) : après l'inscription, le navigateur est rattaché au profil Klaviyo (comme le faisait la pop-up Klaviyo),
       pour que « Viewed Product », « Added to Cart » et « Active on Site » soient suivis pour cet inscrit.
       Si klaviyo.js n'est pas encore chargé, l'appel attend dans sa file officielle (_klOnsite). Aucune erreur ne bloque le ticket. */
    function identify(email) {
      try {
        const kl = window.klaviyo;
        if (kl && typeof kl.identify === 'function') { const p = kl.identify({ email }); if (p && p.catch) p.catch(() => {}); }
        else (window._klOnsite = window._klOnsite || []).push(['identify', { email }]);
      } catch (e) {}
    }
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (busy) return;
      err.hidden = true;
      const email = String(emailIn.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { fail(T.errEmail || '', emailIn); return; }
      if (!consentIn.checked) { fail(T.errConsent || '', consentIn); return; }
      busy = true;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = T.sending || btnLabel;
      const done = (res) => {
        busy = false;
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        btn.textContent = btnLabel;
        if (res !== 'ok') { fail(res === 'invalid' ? (T.errEmail || '') : (T.errNet || ''), res === 'invalid' ? emailIn : null); return; }
        if (!design) { identify(email); st.emailOk = Date.now(); delete st.closedAt; save(); }
        else st.emailOk = Date.now();
        form.reset();
        publish('lp_ticket_email', { campaign: cfg.campaign, lot: lot && lot.id });
        setStep(3, true);
        if (live) live.textContent = (T.announce || '').replace('[lot]', lotText(lot)).replace('[code]', code);
        updateTrigger();
        setTimeout(() => { if (isOpen) { scrollToEl(ticket); focusEl(title); } }, 60);
      };
      if (design) { setTimeout(() => done('ok'), 400); return; }
      subscribe(email).then(done, () => done('error'));
    });

    /* ---------- Copie du code ---------- */
    function copyText(t) {
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t).then(() => true, () => legacyCopy(t));
      return Promise.resolve(legacyCopy(t));
    }
    function legacyCopy(t) {
      const ta = document.createElement('textarea');
      ta.value = t;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;font-size:16px';
      dlg.appendChild(ta);
      ta.select();
      let ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      ta.remove();
      return ok;
    }
    let copyT = 0;
    copyBtn.addEventListener('click', () => {
      if (step !== 3 || !code) return;
      copyText(code).then((ok) => {
        if (!ok) { const r = document.createRange(); r.selectNodeContents(codeEl); const s = getSelection(); s.removeAllRanges(); s.addRange(r); return; }
        copyBtn.textContent = T.copied || '';
        copyBtn.classList.add('is-ok');
        if (live) live.textContent = T.copied || '';
        clearTimeout(copyT);
        copyT = setTimeout(() => { copyBtn.textContent = T.copy || ''; copyBtn.classList.remove('is-ok'); }, 2000);
        publish('lp_ticket_copy', { lot: lot && lot.id });
      });
    });

    /* ---------- Bouton principal : produit offert éventuel, puis lien qui applique le code ---------- */
    cta.addEventListener('click', (e) => {
      publish('lp_ticket_cta', { lot: lot && lot.id, campaign: cfg.campaign });
      if (design || step !== 3) { e.preventDefault(); return; }
      if (!lot || !lot.gift) return;
      e.preventDefault();
      const root = String(cfg.root || '/').replace(/\/?$/, '/');
      const href = cta.href;
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((c) => {
          if ((c.items || []).some((i) => String(i.variant_id) === String(lot.gift))) return null;
          return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(lot.gift), quantity: 1 }] }) });
        })
        .catch(() => null)
        .then(() => { location.href = href; });
    });

    /* ---------- Évènements ---------- */
    if (trg) trg.addEventListener('click', () => open('corner'));
    host.addEventListener('click', (e) => {
      const t = e.target.closest('[data-tk-close], [data-tk-reveal], [data-tk-later], [data-tk-dismiss]');
      if (!t || !host.contains(t)) return;
      if (t.hasAttribute('data-tk-close') || t.hasAttribute('data-tk-later')) { close(); return; }
      if (t.hasAttribute('data-tk-reveal')) { autoScratch(); return; }
      if (t.hasAttribute('data-tk-dismiss')) { if (!design) { st.dismissed = Date.now(); save(); } close(); if (trg && !design) trg.hidden = true; }
    });
    ticket.addEventListener('click', (e) => { if (!revealed && e.detail === 0) autoScratch(); });
    wrap.addEventListener('keydown', (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      const f = focusables();
      if (!f.length) return;
      const first = f[0];
      const lastEl = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dlg.contains(document.activeElement))) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });
    if ('ResizeObserver' in window) {
      let rT = 0;
      new ResizeObserver(() => {
        clearTimeout(rT);
        rT = setTimeout(() => { if (isOpen && drawn && !touched && !revealed) paintCover(); }, 120);
      }).observe(ticket);
    }
    lift();
    if ('MutationObserver' in window) new MutationObserver(lift).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', lift, { passive: true });

    /* ---------- Éditeur de thème ---------- */
    const sec = host.dataset.section;
    if (design) {
      document.addEventListener('shopify:section:select', (e) => { if (document.contains(host) && e.detail && e.detail.sectionId === sec) { st = {}; open('editor'); } });
      document.addEventListener('shopify:section:deselect', (e) => { if (document.contains(host) && e.detail && e.detail.sectionId === sec) close(); });
      document.addEventListener('shopify:block:select', (e) => {
        if (!document.contains(host) || !e.detail || e.detail.sectionId !== sec) return;
        const l = allLots.find((x) => x.id === e.detail.blockId);
        if (!l) return;
        if (isOpen) { isOpen = false; wrap.hidden = true; }
        /* Aperçu de l'étape 3 pour le lot sélectionné. */
        st = { lot: l.id, revealedAt: Date.now(), emailOk: Date.now() };
        open('editor');
      });
    }

    /* Image de la fenêtre chargée un peu avant l'ouverture automatique (pas de bandeau vide). */
    const vImg = $('.tk-v img', host);
    const warm = () => { if (vImg && vImg.loading === 'lazy') vImg.loading = 'eager'; };
    if (trg) trg.addEventListener('pointerenter', warm, { once: true });

    /* ---------- Ouverture automatique ---------- */
    updateTrigger();
    /* V3.11 (Clarity : le ticket recevait 56 % des clics de l'accueil et 45 % des premiers clics) : il s'ouvre après un vrai
       moment de lecture. 1re page vue : délai « delayFirst » (25 s) ; à partir de la 2e page : « delay » (8 s). Jamais
       d'ouverture automatique sur une fiche parfum (réglage skipProduct) ; sur ordinateur, ouverture possible quand la souris
       quitte la page (exitIntent), y compris sur une fiche, puisque le visiteur s'en va. */
    const pvNow = st.pv || 1;
    const autoHere = !(cfg.skipProduct && cfg.template === 'product');
    const firstDelay = cfg.delayFirst != null ? cfg.delayFirst : cfg.delay;
    const need = Math.max(0, (pvNow >= 2 ? cfg.delay : firstDelay) || 0) * 1000;
    if (!design && !st.emailOk && cfg.auto && autoHere) setTimeout(warm, Math.max(0, need - 3000));
    function autoOpen() {
      if (design || !cfg.auto || st.emailOk || st.dismissed) return;
      if (st.closedAt && Date.now() - st.closedAt < (cfg.reopenDays || 30) * DAY) return;
      if ((st.pv || 1) < (cfg.minPages || 1)) return;
      if (store.get('lp_ticket_auto:' + cfg.campaign, true)) return;
      let seen = 0;
      let prev = Date.now();
      let readyAt = 0;
      let maxScroll = 0;
      const onScroll = () => {
        const h = document.documentElement.scrollHeight - innerHeight;
        const p = h > 0 ? (scrollY / h) * 100 : 100;
        if (p > maxScroll) maxScroll = p;
      };
      addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      let onOut = null;
      const stop = () => { removeEventListener('scroll', onScroll); if (onOut) document.removeEventListener('mouseout', onOut); };
      const blocked = () => {
        if (isOpen || document.body.classList.contains('lock') || document.documentElement.classList.contains('menu-on')) return true;
        if (document.querySelector('.drawer.open, .menu.open, .smell-box:not([hidden]), .modal:not([hidden])')) return true;
        const a = document.activeElement;
        if (a && a !== document.body && (a.matches('input, textarea, select') || a.isContentEditable)) return true;
        const others = $$('[role="dialog"], [aria-modal="true"], [id*="pandectes"], [class*="pandectes"], .kl-private-reset-css-Xuajs1');
        if (others.some((el) => !host.contains(el) && visible(el))) return true;
        /* Bannière cookies Pandectes : dans le shadow DOM de <pandectes-cmp> (hôte de 0 x 0 px), invisible pour la recherche ci-dessus. */
        const cmp = document.querySelector('pandectes-cmp');
        const cmpRoot = cmp && cmp.shadowRoot;
        /* Sans test d'opacité : l'animation d'ouverture de la bannière part de 0 et peut être figée (onglet en arrière-plan). */
        return !!cmpRoot && Array.prototype.some.call(cmpRoot.querySelectorAll('dialog, .dialog'), (d) => {
          if ((d.tagName === 'DIALOG' && !d.open) || d.classList.contains('closing')) return false;
          const cs = getComputedStyle(d);
          const r = d.getBoundingClientRect();
          return cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > 120 && r.height > 60;
        });
      };
      const fine = !!(window.matchMedia && matchMedia('(pointer: fine) and (min-width: 900px)').matches);
      if (cfg.exitIntent && fine) {
        const t0 = Date.now();
        onOut = (e) => {
          if (e.relatedTarget || e.clientY > 0 || Date.now() - t0 < 5000) return;
          if (!document.contains(host) || openedOnce || st.emailOk || st.dismissed || st.closedAt || isOpen) return stop();
          if (blocked()) return;
          stop();
          store.set('lp_ticket_auto:' + cfg.campaign, 1, true);
          warm();
          open('exit');
        };
        document.addEventListener('mouseout', onOut);
      }
      if (!autoHere) { removeEventListener('scroll', onScroll); return; }
      const tick = () => {
        /* Déjà ouvert ici (déclencheur en coin), inscrit ou écarté entre-temps : plus d'ouverture automatique. */
        if (!document.contains(host) || openedOnce || st.emailOk || st.dismissed || st.closedAt) return stop();
        const t = Date.now();
        if (!document.hidden) seen += t - prev;
        prev = t;
        if (seen < need || maxScroll < (cfg.scroll || 0)) { setTimeout(tick, 500); return; }
        if (!readyAt) readyAt = t;
        if (t - readyAt > 60000) return stop();
        if (blocked()) { setTimeout(tick, 2000); return; }
        stop();
        store.set('lp_ticket_auto:' + cfg.campaign, 1, true);
        open('auto');
      };
      setTimeout(tick, 500);
    }
    autoOpen();
    host.__tkApi = { open, close, reveal: () => autoScratch(), step: () => step };
  }

  const init = (scope) => { $$('[data-lp-ticket]', scope || document).forEach(setup); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.querySelector && e.target.querySelector('[data-lp-ticket]')) document.documentElement.classList.remove('tk-lock');
  });
})();
